const useWhitelabel = () => {
  const code = process.env.REACT_APP_SCHOOL_CODE;
  return {
    isWhitelabel: Boolean(code),
    schoolCode: code || null,
  };
};

export default useWhitelabel;
